import React from "react";
import memberStore from "./member";
import restaurantStore from "./restaurant";
import favoriteStore from "./favorite";
import voucherStore from "./vouchers";
import reviewStore from "./review"

export const StoresContext = React.createContext({
  memberStore,
  favoriteStore,
  restaurantStore,
  voucherStore,
  reviewStore
});

export const useStores = () => React.useContext(StoresContext);
